export enum ConsolidationKind {
  ReturnsTransfer = "returns_transfer",
  CarrierOverbox = "carrier_overbox",
  CarrierConsolidation = "carrier_consolidation",
}
